export enum DiscountType {
  "PERCENTAGE" = "percentage",
  "NOMINAL" = "nominal",
}
